import React, { useState, useEffect, useRef } from "react";
import { MSG } from "../constants/toastMessages";
import { toast } from 'react-toastify';
import { IoCloseOutline } from "react-icons/io5";
import { apiCallingPost } from "../api/services";
import RegexPattern from "../utils/regexPattern";
import { MdKeyboardArrowDown } from "react-icons/md";
import Select from 'react-select';
import { PhoneNumberUtil } from 'google-libphonenumber';
import CreatableSelect from "react-select/creatable";

const phoneUtil = PhoneNumberUtil.getInstance();

function UserAdd(props) {
  const wrapperRef = useRef(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");
  const [emailId, setemailId] = useState("");
  const [saveFlag, setSaveFlag] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [fullAccessFlag, setFullAccessFlag] = useState(false)
  const [idpUserId, setIdpUserId] = useState("")
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    getCountryList();
    getCompanyList();
    if (props.mode == "Edit") {
      // display_name stays a single column — split on the first space just to populate the
      // two boxes; on save they re-join to the same string (lossless round-trip).
      const dn = (props.selectedUser.display_name || "").trim();
      const sp = dn.indexOf(" ");
      setFirstName(sp === -1 ? dn : dn.slice(0, sp));
      setLastName(sp === -1 ? "" : dn.slice(sp + 1));
      setMobilenumber(props.selectedUser.mobile_number)
      setemailId(props.selectedUser.email_id)
      setFullAccessFlag(props.selectedUser.hasFullAccess)
      setSelectedCountry(props.selectedUser.country_id)
      setIdpUserId(props.selectedUser.idp_user_id)
    }

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSearch(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (props.mode == "Edit") {
      const savedCompany = props.selectedUser.companyName; // from API/DB
      const existing = companyList.find(c => c.value === savedCompany);
      if (existing) {
        setSelectedCompany(existing);
      }
    }
    }, [companyList]);
  const getCompanyList = () => {
    apiCallingPost("api/common/get_all_companies").then((data) => {
      if (data.data.success === "1") {
        const companies = data.data.result.companies || [];
        const formatted = companies.map((c) => ({ value: c, label: c }));
        setCompanyList(formatted);

      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error(MSG.genericError);
    });
  };
  const getCountryList = () => {
    apiCallingPost("api/common/get_country").then((data) => {
      if (data.data.success === "1") {
        const countries = data.data.result || [];
        setCountryList(countries);
        let selected = countries.find(item =>
          props?.selectedUser?.country_id && item.id == props.selectedUser.country_id
        );
        if (!selected) {
          selected = countries.find(item => item.phone_code === "+974");
        }
        if (selected) {
          setSelectedCountry(selected);
        }
      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error(MSG.genericError);
    });
  };

  const isPhoneValid = (number, country) => {
    if (!country || !number) return false;
    try {
      const fullNumber = `${country.phone_code}${number}`;
      const phoneNumber = phoneUtil.parseAndKeepRawInput(fullNumber, country.country_code);
      return phoneUtil.isValidNumber(phoneNumber);
    } catch (error) {
      return false;
    }
  };

  const addUserFn = (e) => {
    e.preventDefault();
    let flag = true;
    if (!firstName.trim()) {
      toast.error(MSG.firstNameRequired);
      document.getElementById("firstName").focus();
      flag = false;
      return;
    }
    // Last name is optional here — an empty one just trims out of fullName below.
    if (!selectedCountry) {
      toast.error(MSG.countryRequired);
      setShowSearch(true);
      return;
    }

    if (!mobilenumber || !isPhoneValid(mobilenumber, selectedCountry)) {
      toast.error(MSG.mobileInvalid);
      document.getElementById("mobilenumber").focus();
      return;
    }
    if (!emailId || !RegexPattern.Email.test(emailId)) {
      toast.error(MSG.emailInvalid);
      document.getElementById("emailId").focus();
      flag = false;
      return;
    }
    // Task #13: admin no longer sets a password. The BE creates a pending account and
    // emails the user a "set your password" activation link.

    const milliseconds = new Date().getTime();
    // Two input boxes, one column: concatenate to the single display_name (no schema change).
    const fullName = `${firstName.trim()} ${lastName.trim()}`.trim();

    let url = ""
    let postData
    setSaveFlag(true)
    if (flag && props.mode === "Add") {
      postData = {
        display_name: fullName,
        mobile_number: mobilenumber,
        email_id: emailId,
        // No password — omitting it triggers the BE invite/activation flow (task #13).
        created_on: milliseconds,
        role_id: 3,
        country_id: selectedCountry?.id || "",
        hasFullAccess: fullAccessFlag,
        company: selectedCompany?.value || ""
      };
      url = "api/authentication/userSignup"
    }
    else {
      postData = {
        display_name: fullName,
        mobile_number: mobilenumber,
        email_id: emailId,
        updated_on: milliseconds,
        id: props.selectedUser?.id,
        country_id: selectedCountry?.id || "",
        hasFullAccess: fullAccessFlag,
        company: selectedCompany?.value || ""
      };
      url = "api/authentication/userUpdate"
    }

    apiCallingPost(url, postData).then((data) => {
      setTimeout(() => {
        setSaveFlag(false)
      }, 500);
      if (data.data.success === "1") {
        if (props.mode === "Add") {
          // Invite sent — the BE created a pending account and emailed the activation link.
          // Identity creation happens when the user sets their password, not here.
          toast.success(MSG.inviteSent);
        }
        else {
          toast.success(MSG.userUpdated);

          let postData = {
            "email": emailId,
            // "password": password,
            "displayName": fullName,
            "mobile_number": selectedCountry?.phone_code + mobilenumber,
            "uid": idpUserId
          }

          // The account row is already saved; if its sign-in identity could not be
          // updated (e.g. new email rejected), the admin must know — the two are now
          // out of step and the user may not be able to log in.
          apiCallingPost("api/authentication/edit_idp_user", postData).then((data) => {
            if (data.data.success !== "1") toast.error(MSG.idpUpdateFailed);
          }).catch(() => {
            toast.error(MSG.idpUpdateFailed);
          });
        }
        setTimeout(() => {
          props.setActivePage(1)
          props.setOffset(0)
          props.cancelPopup();
          props.userListFn("", 0)
        }, 1000);
      } else {
        toast.error(data.data.errorMessage);
      }
    }).catch((error) => {
      props.cancelPopup();
    });
  }
  const customFilter = (option, inputValue) => {
    return (
      option.data.name.toLowerCase().includes(inputValue.toLowerCase()) ||
      option.data.phone_code.includes(inputValue)
    );
  };
  const handleChange = (selected) => {
    setSelectedCompany(selected);
  };
  const handleInputChange = (inputValue, { action }) => {
    if (action === "input-change") {
      // while typing, store as selected
      setSelectedCompany({ value: inputValue, label: inputValue });
    }
  };
  return (

    <div className="modal-admin-wrapper add-admin">
      <div className="modal-ad-popup modal-md">
        <div className="modal-innerpopup ">
          <div className="modal-headdiv d-flex justify-content-between">
            <h5 className="modal-head">Add User </h5>
            <span className="closeBtn"><IoCloseOutline size={32} onClick={() => props.cancelPopup()} /></span>
          </div>
          <div className="modal-admin-body">
            <div className="col-12">
              <div className="form_div">
                <input
                  type="text"
                  id="firstName"
                  placeholder="First Name"
                  aria-label="First Name"
                  autoComplete="given-name"
                  className="form-register-popup"
                  value={firstName}
                  onChange={(e) => {
                    if (/^[a-zA-Z. ]*$/.test(e.target.value))
                      setFirstName(e.target.value)
                  }}
                />
              </div>
              <div className="form_div">
                <input
                  type="text"
                  id="lastName"
                  placeholder="Last Name (optional)"
                  aria-label="Last Name (optional)"
                  autoComplete="family-name"
                  className="form-register-popup"
                  value={lastName}
                  onChange={(e) => {
                    if (/^[a-zA-Z. ]*$/.test(e.target.value))
                      setLastName(e.target.value)
                  }}
                />
              </div>
              <div className="form_div"
                ref={wrapperRef}
              >
                <div className=" form-relative-select">
                  <div className="select-sub-class">
                    <div onClick={() => setShowSearch(!showSearch)} >
                      {selectedCountry?.phone_code}
                      <MdKeyboardArrowDown />
                    </div>
                    {showSearch &&
                      <div className="menuIsOpen-select">
                        <Select
                          classNamePrefix="select"
                          id="countrySelect"
                          isSearchable
                          options={countryList}
                          value={selectedCountry}
                          onChange={(selectedOption) => {
                            setSelectedCountry(selectedOption);
                            setShowSearch(false);
                          }}
                          getOptionValue={(option) => option.id}
                          getOptionLabel={(option) => `${option.name}`}
                          filterOption={customFilter}
                          placeholder="Search country code..."
                          noOptionsMessage={({ inputValue }) =>
                            inputValue ? `No country codes found for "${inputValue}"` : "No country codes available"
                          }
                          menuIsOpen
                          autoFocus
                        />
                      </div>
                    }
                  </div>
                  <input
                    type="number"
                    id="mobilenumber"
                    placeholder="Mobile Number"
                    className="form-register-popup mb-0"
                    value={mobilenumber}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, ''); // Removes non-numeric characters
                      setMobilenumber(value);
                    }}
                    inputMode="numeric"
                  />
                </div>
              </div>
              <div className="form_div">
                <input
                  type="text"
                  id="emailId"
                  placeholder="Email Id"
                  value={emailId}
                  onChange={(e) => setemailId(e.target.value)}
                  className="form-register-popup"
                />
              </div>
              {props.mode == "Add" &&
                <p className="text-muted mb-3" style={{ fontSize: '12px' }}>
                  The user will receive an email to set their own password and activate their account.
                </p>
              }

              <div className="form_div mb-3">
                <CreatableSelect
                  options={companyList}
                  value={selectedCompany}
                  onChange={handleChange}
                  onInputChange={handleInputChange}
                  placeholder="Select or Type company name"
                  isClearable={false}
                  isSearchable
                  classNamePrefix="select"
                  formatCreateLabel={(inputValue) => `${inputValue}`} // custom text when typing
                />

              </div>

              <div className="form_div d-flex align-items-center gap-2 mb-2 ms-3">
                <label className="custom-checkbox mt-1">
                  <input type="checkbox" aria-hidden="true"
                    checked={fullAccessFlag}
                    onChange={() => setFullAccessFlag(!fullAccessFlag)}
                  /><span className="checkmark"></span>
                </label> Full Access
              </div>

              <button
                type="submit"
                disabled={saveFlag}
                className="accept-all-btn w-100 py-2 mt-3"
                onClick={addUserFn}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserAdd;
